import mobile from 'is-mobile';

export function isPhone(device = navigator) {
  return device.userAgentData?.mobile === true || mobile({ ua: device.userAgent });
}
